import API from 'app/utils/apiClient';
import { toParams } from 'app/utils/url';

const addShareCount = (userId) => API.post(`/event/share/users/${userId}/`);

const getAuthorInfo = () => API.get('/event/author/users/me/');

const getAuthorRanks = (page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/event/author/rank/?${params}`);
};

const getReaderInfo = () => API.get('/event/reader/users/me/');

const getVoteEventStories = () => API.get('/vote-event/');

const getVoteEventStory = (id) => API.get(`/vote-event/stories/${id}/`);

const voteStory = (id) => API.post(`/vote-event/stories/${id}/histories/`);

// thanksgiving
const getMissionEvents = () => API.get('/mission-event/');

const postMission = (type) => API.post(`/mission-event/complete/`, { type });

const postMissionResult = () => API.post('/mission-event/random-items/');

// star event
const getStarEvent = (code) => API.get(`/star-events/${code}/`);

const getStarEventDashboard = (code) =>
  API.get(`/star-events/${code}/dashboard/`);

const postStarEventReward = (code, itemId) =>
  API.post(`/star-events/${code}/apply/${itemId}/`);

export default {
  addShareCount,
  getAuthorInfo,
  getAuthorRanks,
  getReaderInfo,
  getVoteEventStories,
  getVoteEventStory,
  voteStory,
  // thanksgiving
  getMissionEvents,
  postMission,
  postMissionResult,
  // star event
  getStarEvent,
  getStarEventDashboard,
  postStarEventReward,
};



// WEBPACK FOOTER //
// ./src/app/apis/event.js